import { Tooltip, Box, Text } from "@chakra-ui/react";
import { formatPrice } from "../functions";

interface ListPriceInterface {
    listPriceAdjusted?: boolean;
    listPrice?: number;
}

const ListPrice = ({ listPriceAdjusted, listPrice }: ListPriceInterface) => {

    return (
        <Tooltip label={listPriceAdjusted ? "List price adjusted" : ""} hasArrow>
            <Box
                border={listPriceAdjusted ? "1px solid" : "none"}
                borderColor={listPriceAdjusted ? "red.400" : "transparent"}
                borderRadius="md"
                px={2}
                py={1}
                display="inline-block"
            >
                <Text
                    color={listPriceAdjusted ? "red.600" : "gray.900"}
                    fontSize="sm"
                    fontWeight="medium"
                    cursor={listPriceAdjusted ? "help" : "default"}
                >
                    {listPrice ? formatPrice(listPrice) : '-'}
                </Text>
            </Box>
        </Tooltip>
    );
};

export default ListPrice;